import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {SidebarService} from "../shared/services/sidebar.service";

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.less'],
})
export class LayoutComponent implements OnInit {

  collapsedSidebar: boolean;

  constructor(public _sidebarService: SidebarService) {

  }

  ngOnInit() {
    this.collapsedSidebar = false;
  }

  setSideBar(event) {
    // setTimeout solve Error : ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      this.collapsedSidebar = event;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/layout/layout.component.ts